import { useRuntimeConfig } from '#imports'

let greenhouseScriptPromise: Promise<void> | null = null

export async function loadGreenhouseEmbeddedJobApplication(
  jobId: string,
  options?: {
    sourceToken?: string
    ccuid?: string
  }
) {
  await greenhouseJobBoardScriptReady()

  const embedRoot = document.getElementById('grnhse_app')

  if (!embedRoot) {
    throw new Error('Greenhouse embed root #grnhse_app was not found')
  }

  embedRoot.innerHTML = ''
  window.Grnhse!.Iframe.load(jobId, options?.sourceToken, options?.ccuid)
}

async function greenhouseJobBoardScriptReady() {
  if (typeof window === 'undefined') {
    throw new Error('Greenhouse embed can only be loaded in the browser')
  }

  if (window.Grnhse?.Iframe?.load) {
    return
  }

  if (!greenhouseScriptPromise) {
    greenhouseScriptPromise = loadGreenhouseJobBoardScript()
  }

  await greenhouseScriptPromise
}

async function loadGreenhouseJobBoardScript() {
  const { jobBoard } = useRuntimeConfig().public
  const greenhouseJobBoardScriptUrl = `https://boards.greenhouse.io/embed/job_board/js?for=${jobBoard}`
  const existingScript = document.querySelector<HTMLScriptElement>(`script[src="${greenhouseJobBoardScriptUrl}"]`)

  if (existingScript) {
    await Promise.resolve()

    if (!window.Grnhse?.Iframe?.load) {
      throw new Error('Greenhouse embed script is already present but the iframe API is unavailable')
    }

    return
  }

  const script = document.createElement('script')
  script.src = greenhouseJobBoardScriptUrl
  script.async = true

  await new Promise<void>((resolve, reject) => {
    script.addEventListener('load', () => resolve(), { once: true })
    script.addEventListener('error', () => reject(new Error('Failed to load the Greenhouse embed script')), {
      once: true
    })
    document.body.appendChild(script)
  })

  if (!window.Grnhse?.Iframe?.load) {
    throw new Error('Greenhouse embed loaded without exposing the iframe API')
  }
}
